<template>
  <q-menu
    ref="popup"
    class="w-full max-w-[34.25rem] overflow-hidden border border-neutral-100/10 shadow-xl sm:!max-w-full"
    :offset="[0, 5]"
    @show="loadItems"
  >
    <OInput
      v-model="search"
      label="Comparar com"
      size="md"
      clearable
      debounce="400"
    >
      <template v-slot:prepend>
        <q-icon name="search" size="1.5rem" class="text-neutral-70" />
      </template>
    </OInput>

    <div class="flex gap-8 px-16 pt-16 pb-8">
      <button
        v-for="(_filter, _index) in filters"
        :key="_index"
        class="text-paragraph-3 text-neutral-70 px-10 h-24 rounded-md border border-[#E7E8E9] bg-white transition"
        :class="[
          _filter === activeFilter
            ? '!border-primary-pure !bg-primary-pure/10 text-primary-pure !text-headline-3'
            : 'hover:brightness-95',
          isFilterDisabled(_filter)
            ? 'opacity-50 cursor-not-allowed'
            : '',
        ]"
        :disabled="isFilterDisabled(_filter)"
        @click="activeFilter = _filter"
      >
        {{ _filter }}
      </button>
    </div>

    <q-list class="overflow-y-auto max-h-[20rem]">
      <q-item
        v-if="filtersLoading"
        class="flex items-center gap-8 py-0 px-16 h-40 border-t border-neutral-100/10 text-headline-3 text-neutral-40 !font-normal pointer-events-none"
      >
        <q-spinner-tail color="primary" size="1.25rem" />
        <span>Carregando ...</span>
      </q-item>

      <q-item
        v-else-if="comparationItems.length === 0"
        class="flex items-center py-0 px-16 h-40 border-t border-neutral-100/10 text-headline-3 text-neutral-40 !font-normal pointer-events-none"
      >
        <span>Nada encontrado.</span>
      </q-item>

      <template v-else>
        <q-item
          v-for="(_item, _index) in comparationItems"
          :key="_index"
          class="flex items-center py-0 px-16 h-40 border-t border-neutral-100/10 text-headline-3 text-neutral-70 !font-normal first:border-t-0"
          clickable
          @click="onEmitParam(_item)"
        >
          {{ _item.label }}
        </q-item>
      </template>
    </q-list>
  </q-menu>
</template>

<script setup>
import { ref } from 'vue'
import OInput from 'components/Input/OInput.vue'
import useCopaReports from 'composables/useCopaReports'

import {
  comparationItems,
  filters,
  activeFilter,
  filtersLoading,
} from 'store/copa.stores'

const { search, loadItems, isFilterDisabled } = useCopaReports()

const popup = ref(null)

const onEmitParam = (param) => {
  emit('update:param', param)
  popup.value.hide()
}

const emit = defineEmits(['update:param'])
</script>

<style scoped lang="sass">
.q-field--float :deep(.q-field__label.no-pointer-events.absolute.ellipsis)
  display: none
</style>
